// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": process.env.VUE_APP_AWS_MOBILE_AWS_PROJECT_REGION,
    Auth: {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: process.env.VUE_APP_AWS_MOBILE_AUTH_IDENTITYPOOLID,
        // OPTIONAL - Amazon Cognito Federated Identity Pool Region
        // Required only if it's different from Amazon Cognito Region
        /*
                identityPoolRegion: 'XX-XXXX-X',
        */
        // REQUIRED - Amazon Cognito Region
        region: process.env.VUE_APP_AWS_MOBILE_AUTH_REGION ,
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.VUE_APP_AWS_MOBILE_AUTH_USERPOOLID,
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: process.env.VUE_APP_AWS_MOBILE_AUTH_USERPOOLWEBCLIENTID,
    },
    Storage: {
        bucket: process.env.VUE_APP_AWS_MOBILE_STORAGE_BUCKET, //REQUIRED -  Amazon S3 bucket
        region: process.env.VUE_APP_AWS_MOBILE_STORAGE_REGION, //REQUIRED -  bucket region
    }

    /*
            // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
            mandatorySignIn: false,

            // OPTIONAL - Configuration for cookie storage
            cookieStorage: {
                // REQUIRED - Cookie domain (only required if cookieStorage is provided)
                domain: '.yourdomain.com',
                // OPTIONAL - Cookie path
                path: '/',
                // OPTIONAL - Cookie expiration in days
                expires: 365,
                // OPTIONAL - Cookie secure flag
                secure: true
            },

            // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
            authenticationFlowType: 'USER_PASSWORD_AUTH'
    */
};

export default awsmobile;
